import { createRoot } from "react-dom/client";
import { Configuration } from "../../hocs/configuration";
import { LaunchDarklyFeatureFlagInit, PutLDFlagIntoState } from "../../hocs/launchDarkly";
import { Authentication } from "../../hocs/authenticate";
import { Provider } from "react-redux";
import store from "../../store";
import App from "../../App";

/* global document, Office, HTMLElement */

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

/* /* Render application after Office initializes */
Office.onReady(() => {
  root?.render(
    <Provider store={store}>
      <Configuration>
        <Authentication>
          <LaunchDarklyFeatureFlagInit>
            <PutLDFlagIntoState>
              <App />
            </PutLDFlagIntoState>
          </LaunchDarklyFeatureFlagInit>
        </Authentication>
      </Configuration>
    </Provider>
  );
});
